<div class="recorder_modal">
  <p class="recorder_modal_title">Share Audit</p>

  <label class="custom-input_field_withoutIcon" style="width: 100%">
    <span class="custom-input_field-label">
      Email of the person you are sending it to
    </span>
    <input
      class="custom-input_field"
      matInput
      id="share-audit-email"
      type="email"
      autocomplete="off"
      placeholder="name@company.com"
      [(ngModel)]="email"
      (keyup.enter)="share()"
    />
  </label>

  <p class="share-audit_hint">
    The shareable link is copied to your clipboard.
  </p>

  <div class="button_container" style="margin-top: 30px">
    <button mat-raised-button (click)="dialogRef.close()" class="seo_cancel">
      Cancel
    </button>
    <button
      mat-raised-button
      type="submit"
      class="primary"
      mat-button
      (click)="share()"
      [disabled]="!isValid"
    >
      Share
    </button>
  </div>
</div>
